import { createSelector } from 'reselect';
import {
    handleRehydrateAction,
    handleRemoveAction,
    handleSubmitAction
} from '../../../core/store/helpers/reducer-helper';
import * as fromReportLayoutActions from './report-layout.actions';
import { ReportLayout } from './report-layout.model';

export interface State {
    ids: Array<string>;
    entities: { [id: string]: ReportLayout };
}

export const initialState: State = {
    ids: [],
    entities: {}
};

// tslint:disable-next-line:only-arrow-functions
export function reducer(state = initialState, action: fromReportLayoutActions.Actions): State {
    switch (action.type) {
        case fromReportLayoutActions.SUBMIT: {
            return handleSubmitAction(state, action);
        }
        case fromReportLayoutActions.REHYDRATE: {
            return handleRehydrateAction(state, action);
        }
        case fromReportLayoutActions.REMOVE: {
            return handleRemoveAction(state, action);
        }
        default: {
            return state;
        }
    }
}

export const getEntities = (state: State) => state.entities;

export const getIds = (state: State) => state.ids;

export const getAll = createSelector(getEntities, getIds, (entities, ids) => ids.map(id => entities[id]));



// WEBPACK FOOTER //
// ./src/vas/business-objects/report-layout/report-layout.reducer.ts